import { useEffect, useState } from "react";
import { Button } from "antd";
import Main from "../../components/layout/Main";
import TumbnailImage from "../../assets/images/poadcasts-image.jpg";
import ClockImage from "../../assets/images/clock-image.svg";
import PoadcastcenterImage from "../../assets/images/POADCAST-CENTER-IMAGE.svg";
import { usePodcast } from "../../context/PodcastContext";
import { useNavigate } from "react-router";
import { useParams } from "react-router";
import {
  DEFAULT_LIMIT,
  DEFAULT_PAGE,
  getAudioDuration,
  isScrollAtBottom,
  isValidUrl,
} from "../../helper/functions";
import { ImageNotAvailable } from "../../constants/urls";

// const podcastCategories = ["All", "News", "Technology", "Games", "Minecraft"];

const PodcastsListIndex = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const Navigate = useNavigate();
  const [podcasts, setPodcasts] = useState([]);
  const [podcastCategories, setPodcastCategories] = useState(["All"]);

  const { loadPodCasts } = usePodcast();
  const { year } = useParams();
  // Pagination States
  const [page, setPage] = useState(DEFAULT_PAGE);
  const limit = DEFAULT_LIMIT;
  const [hasMore, setHasMore] = useState(true);

  const params = { page, limit, year };
  const filteredPodcasts = podcasts.filter(
    (p) => activeCategory === "All" || p.category === activeCategory
  );

  // ------------- handlers ------------
  const fetchPodcasts = async (reset = false) => {
    try {
      const response = await loadPodCasts(params);

      // First get all keys
      const keys = Object.keys(response.data.all);
      setPodcastCategories((prev) => {
        const formatted = keys.map(
          (k) => k.charAt(0).toUpperCase() + k.slice(1)
        );
        const all = [...prev, ...formatted];
        return [...new Set(all)];
      });

      // const allPodcasts = await Promise.all(
      //   Object.keys(response.data.all).flatMap((categoryKey) =>
      //     response.data.all[categoryKey].map(async (item) => {
      //       const duration = await getAudioDuration(item.audioUrl);
      //       return {
      //         title: item.title,
      //         player: item.author || "N/A",
      //         views: duration,
      //         audioUrl: item.audioUrl,
      //         language: item.language,
      //         status: item.status,
      //         imageUrl: item.coverImageUrl,
      //         comments: item.comments,
      //         likes: item.likes,
      //         podcastId: item.podcastId,
      //         description: item.description,
      //         _id: item._id,
      //         category:
      //           categoryKey.charAt(0).toUpperCase() + categoryKey.slice(1),
      //         year: new Date(item.publishDate).getFullYear(),
      //       };
      //     })
      //   )
      // );

      const allPodcasts = Object.keys(response.data.all).flatMap(
        (categoryKey) =>
          response.data.all[categoryKey].map((item) => ({
            title: item.title,
            player: item.author || "N/A",
            audioUrl: item.audioUrl,
            language: item.language,
            status: item.status,
            imageUrl: item.coverImageUrl,
            comments: item.comments,
            likes: item.likes,
            podcastId: item.podcastId,
            description: item.description,
            _id: item._id,
            category:
              categoryKey.charAt(0).toUpperCase() + categoryKey.slice(1),
            year: new Date(item.publishDate).getFullYear(),
          }))
      );

      // console.log("all podcasts in year page", allPodcasts);
      // RESET means category/year changed → load fresh
      if (reset) {
        setPodcasts(allPodcasts);
      } else {
        setPodcasts((prev) => [...prev, ...allPodcasts]);
      }

      // console.log("podcasts in year page ===", podcasts);
      // Check if more pages exist
      if (allPodcasts.length < limit) {
        setHasMore(false);
      }

      // setPodcasts(allPodcasts);
    } catch (error) {
      console.log("error-->", error);
    }
  };

  const handleScroll = (e) => {
    if (isScrollAtBottom(e) && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  // ---------- use effect ------------
  useEffect(() => {
    fetchPodcasts();
  }, []);

  useEffect(() => {
    if (page > 1) fetchPodcasts();
  }, [page]);

  useEffect(() => {
    setPage(DEFAULT_PAGE);
    setHasMore(true);
    fetchPodcasts(true);
  }, [year, activeCategory]);

  return (
    <Main>
      <div
        className="podcast-page podcast-page-by-year"
        onScroll={handleScroll}
      >
        <div className="orange-header">Podcasts</div>

        <div className="game-modes-filter" style={{ marginBottom: 20 }}>
          {podcastCategories.map((cat) => (
            <Button
              key={cat}
              type={activeCategory === cat ? "primary" : "default"}
              onClick={() => setActiveCategory(cat)}
              className="mode-filter-btn"
              style={{ marginRight: 8 }}
            >
              {cat}
            </Button>
          ))}
        </div>

        <section className="for-upcoming-tumanents podcasts-main-list">
          <div className="for-live-video-grid-wrapper expanded">
            <div className="for-feature-grid-main">
              {filteredPodcasts.map((item, index) => (
                <div key={index} className="for-live-video-grid-inner">
                  <div
                    className="for-live-video-grid-inner-image"
                    style={{ position: "relative" }}
                    onClick={() =>
                      Navigate(`/podcasts/${item.year}/${item._id}`)
                    }
                  >
                    <img
                      src={
                        isValidUrl(item.imageUrl)
                          ? item.imageUrl
                          : ImageNotAvailable
                      }
                      alt="thumbnail"
                    />
                    <h5>
                      <img src={ClockImage} alt="clock" /> {item.views}
                    </h5>
                    <div className="center-image-podcasts">
                      <img src={PoadcastcenterImage} alt="center-icon" />
                      <div
                        className="image-gradient"
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: "60%",
                          background:
                            "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.9) 88.31%)",
                        }}
                      />
                    </div>
                  </div>
                  <div className="for-live-video-grid-footer">
                    <div className="for-player-text">
                      <h5>{item.title}</h5>
                      <p>{item.player}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </Main>
  );
};

export default PodcastsListIndex;
